<template>
<div :class="`wrapper  wrapper--${table_style} m-3 p-2`">

    <div>
        <div class="text-center p-2">
            <h3 class="text-center">ROI per inkoper</h3>
            <hr>
            <span @click="previousDay"><i class="fas fa-arrow-left"></i></span>
            <input type="date" :value="full_date" @change="handleDateChange" class="mx-2" />
            <span @click="nextDay"><i class="fas fa-arrow-right"></i></span>
        </div>
        <Loading v-if="loading" />
        <div v-else>
            <div class="p-2">
                <h4 class="text-center">ROI totaal</h4>
                <table :class="` table--perweek table__border--${table_style}`">
                    <thead :class="`table__head--${table_style}`">
                        <th class="table__head--text" style="width: 200px;">Naam</th>
                        <th class="table__head--text table__data--right" style="width: 200px;">ROI *1</th>
                        <th class="table__head--text table__data--right" style="width: 200px;">Totale marge</th>
                        <th class="table__head--text table__data--right" style="width: 200px;">Gem. stadagen</th>
                        <th class="table__head--text table__data--right" style="width: 200px;">Afleveringen</th>

                        <th class="table__head--text table__data--right" style="width: 300px;">Totaal geïnvesteerd vermogen *3</th>
                    </thead>
                    <tbody>
                        <tr v-for="(item) in buyer_roi" :key=item :class="`table__row--color`">
                            <td class="table__cell--default">{{ item.inkopernaam }}</td>
                            <td class="table__cell--default text-center">{{ item.roi }} %</td>
                            <td class="table__cell--default table__data--right">€ {{ item.marge }}</td>

                            <td class="table__cell--default table__data--right">{{ item.avg_stadagen }}</td>
                            <td class="table__cell--default table__data--right">{{ item.afleveringen }}</td>

                            <td class="table__cell--default table__data--right">€ {{ item.geinvesteerd_vermogen }}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <th></th>
                        <th class="table__data--right text-center">{{ buyer_roi_totals.weighted_avg_roi }} %</th>
                        <th class="table__data--right">€{{ buyer_roi_totals.totale_marge }}</th>
                        <th class="table__data--right">{{ buyer_roi_totals.avg_stadagen }}</th>
                        <th class="table__data--right">{{ buyer_roi_totals.totale_afleveringen }}</th>

                        <th class="table__data--right">€ {{ buyer_roi_totals.totaal_geinvesteerd_vermogen }}</th>
                    </tfoot>
                </table>
            </div>
            <div class="p-2">
                <h4 class="text-center">ROI na voorraadcorrectie</h4>
                <table :class="`w-100 table--perweek table__border--${table_style}`">
                    <thead :class="`table__head--${table_style}`">
                        <th class="table__head--text" style="width: 200px;">Naam</th>
                        <th class="table__head--text table__data--right" style="width: 200px;">ROI na voorraadcorrectie *2</th>
                        <th class="table__head--text table__data--right" style="width: 200px;">Totale marge</th>
                        <th class="table__head--text table__data--right" style="width: 200px;">Gem. stadagen</th>

                        <th class="table__head--text table__data--right" style="width: 200px;">Totale voorraad</th>
                        <th class="table__head--text table__data--right" style="width: 300px;">Voorraad > 180 dagen</th>
                        <th class="table__head--text table__data--right">Geinvesteerd vermogen correctie</th>
                        <th class="table__head--text table__data--right">Geïnvesteerd vermogen na correctie *4</th>
                    </thead>
                    <tbody>
                        <tr v-for="(item) in buyer_roi" :key=item :class="`table__row--color`">
                            <td class="table__cell--default">{{ item.inkopernaam }}</td>
                            <td class="table__cell--default text-center">{{ item.roi_na_correctie }} %</td>
                            <td class="table__cell--default table__data--right">€ {{ item.marge }}</td>
                            <td class="table__cell--default table__data--right">{{ item.avg_stadagen }}</td>
                            <td class="table__cell--default table__data--right">{{ item.voorraad }}</td>
                            <td class="table__cell--default table__data--right">{{ item.voorraad_langstaand }}</td>
                            <td class="table__cell--default table__data--right">€{{ item.voorraad_correctie }}</td>
                            <td class="table__cell--default table__data--right">€ {{ item.geinvesteerd_vermogen_na_correctie }}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <th></th>
                        <th class="table__data--right text-center">{{ buyer_roi_totals.weighted_avg_roi_na_correctie }} %</th>

                        <th class="table__data--right">€ {{ buyer_roi_totals.totale_marge }}</th>
                        <th class="table__data--right">{{ buyer_roi_totals.avg_stadagen }}</th>
                        <th class="table__data--right">{{ buyer_roi_totals.totale_voorraad }}</th>
                        <th class="table__data--right">{{ buyer_roi_totals.totale_voorraad_langstaand }}</th>
                        <th class="table__data--right">€ {{ buyer_roi_totals.totale_voorraad_correctie }}</th>
                        <th class="table__data--right">€ {{ buyer_roi_totals.totaal_geinvesteerd_vermogen_na_correctie }}</th>
                    </tfoot>
                </table>
            </div>
            <div class="mt-2">
                <strong>
                    *1 De formule van ROI = Marge/ Geïnvesteerd vermogen * 100%. De ROI is gebaseerd op de afleveringen vanaf het begin van elk jaar.<br />
                    <br />
                    *2 Bij de ROI-berekening is rekening gehouden met de voorraad > 180 stadagen en het daaruit verwachte rendement.<br />
                    <br />
                    *3 Het totaal geïnvesteerd vermogen is berekend door de totale inkoopwaarde van het voertuig te relateren aan de totale stadagen van het voertuig.<br />
                    <br />
                    *4 Het totaal geinvesteerd vermogen na het optellen van de voorraadcorrectie.
                </strong>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import request from "@/functions/request.js";
import Loading from "@/components/Loading.vue";
import {
    subtractTime,
    addTime
} from "@/functions/date.js";
import moment from "moment";

export default {
    props: ["bu"],
    components: {
        Loading
    },
    data: () => ({
        loading: null,
        buyer_roi: null,
        buyer_roi_totals: null,
        full_date: null,
        table_style: null,
        buyer_roi_soort: null,
    }),

    created() {
        this.loading = true;
        this.table_style = this.bu == 202 ? 200 : this.bu
        this.full_date = moment()
        this.getData(this.bu);
    },
    watch: {
        bu(newbu) {
            this.table_style = newbu == 202 ? 200 : newbu
            this.full_date = moment();
            this.getData(newbu);
        }
    },
    methods: {
        getData(bu) {
            this.loading = true;
            this.full_date = moment(this.full_date).format('YYYY-MM-DD')

            request(`buyers-roi/${bu}/${this.full_date}`).then(({
                buyer_roi,
                buyer_roi_totals
            }) => {
                this.buyer_roi = buyer_roi;
                this.buyer_roi_totals = buyer_roi_totals;
                this.loading = false;

            })
        },

        previousDay() {
            this.full_date = subtractTime(1, this.full_date, "days");
            this.getData(this.bu);
        },

        nextDay() {
            this.full_date = addTime(1, this.full_date, "days");
            this.getData(this.bu);
        },

        handleDateChange(event) {
            this.full_date = event.target.value;
            this.getData(this.bu)
        }
    }
}
</script>
